var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.21973 9.66634C5.21973 8.38446 5.76968 7.15508 6.74861 6.24866C7.72754 5.34223 9.05525 4.83301 10.4397 4.83301H20.8795C22.2639 4.83301 23.5916 5.34223 24.5706 6.24866C25.5495 7.15508 26.0995 8.38446 26.0995 9.66634V19.333C26.0995 20.6149 25.5495 21.8443 24.5706 22.7507C23.5916 23.6571 22.2639 24.1663 20.8795 24.1663H10.4397C9.05525 24.1663 7.72754 23.6571 6.74861 22.7507C5.76968 21.8443 5.21973 20.6149 5.21973 19.333V9.66634Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.532 9.0625V9.07458M11.7446 14.5C11.7446 15.4614 12.1571 16.3834 12.8913 17.0633C13.6255 17.7431 14.6213 18.125 15.6596 18.125C16.6979 18.125 17.6937 17.7431 18.4279 17.0633C19.1621 16.3834 19.5745 15.4614 19.5745 14.5C19.5745 13.5386 19.1621 12.6166 18.4279 11.9367C17.6937 11.2569 16.6979 10.875 15.6596 10.875C14.6213 10.875 13.6255 11.2569 12.8913 11.9367C12.1571 12.6166 11.7446 13.5386 11.7446 14.5Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIconGrey);
export default __webpack_public_path__ + "static/media/instagramIconGrey.5b98bf67ec30d9bce57b00081440873a.svg";
export { ForwardRef as ReactComponent };